// extracted by mini-css-extract-plugin
export default {"whatsappCon":"layout_whatsappCon__LuPCu","FromTop":"layout_FromTop__ui5FE","pages":"layout_pages__ZZMi5"};